/// <reference path="Configuracion.js" />
/// <reference path="Constantes.js" />
/// <reference path="controlador.js" />
/// <reference path="eventosPantallaInicial.js" />
/// <reference path="ListaEmpresas.js" />

var oNavegacion;

function GetObjNavegacion()
{
    if (oNavegacion == undefined)
    {
        oNavegacion = new ObjNavegacion();
    }
    return oNavegacion;
}

function ObjNavegacion()
{
    var that = this;

    this.InicializaWindowsLocation = function ()
    {
        window.onhashchange = that.locationCatalogoHashChanged;
    }
        
    this.locationCatalogoHashChanged = function ()
    {
        var newHash = location.hash;

        //si hacemos back hasta llegar a la página inicial
        if (newHash == "")
        {
            GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO'); //window.newHash = '#LEMPRESAS&p=1&t=TODO';
            return;
        }
        else
        {
            var tieneParametros = (newHash.indexOf('?') > 0);
            var tieneVariosParametros = (newHash.indexOf('&') > 0);

            var numPagina = "";
            var idioma = "";
            var tipoBusqueda = "";
            var numEmpresas = "";
            var txtBusqueda = "";

            if (tieneVariosParametros)
            {
                numPagina = sacaParametro('p', newHash);
                idioma = sacaParametro('i', newHash);
                tipoBusqueda = sacaParametro('t', newHash);
                numEmpresas = sacaParametro('e', newHash);
                txtBusqueda = sacaParametro2('b', newHash);
            }

            var opcionElegidaIndice = "";

            if (newHash.search("#MAPA_FERIA") >= 0)
            {
                if (GetObjConfiguracion().verPIM === 'S')
                    GetObjControlador().imprimirPIM(GetObjConstantes()._MAPA_FERIA, newHash);

                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'M');
                var stand = (tieneParametros) ? sacaParametro('s', newHash) : '';
                GetObjControlador().cargarMapaFeria(stand);
                GetObjControlador().saveAnalyticsOtros("Plano General", 
                    (stand === '') ? 'Sin STAND' : 'STAND: ' + stand);
            }
            else if (newHash.search("#MAPA_PABELLON") >= 0)
            {
                if (GetObjConfiguracion().verPIM === 'S')
                    GetObjControlador().imprimirPIM(GetObjConstantes()._MAPA_PABELLON, newHash);

                GetFavoritos().LoadArrayFavoritos();

                var pabellon = (tieneParametros) ? sacaParametro('p', newHash) : "";
                var stand = (tieneParametros) ?  sacaParametro('s', newHash) : "";
                GetObjControlador().cargarMapaPabellon(pabellon, stand);               
                GetObjControlador().saveAnalyticsOtros("Plano Pabellón",
                    (stand === "") ? "Sin STAND" : "PABELLON: " + pabellon + "  STAND: " + stand);
            }
            else if (newHash.search("#FICHA_EMPRESA") >= 0)
            {
                if (GetObjConfiguracion().verPIM === 'S')
                    GetObjControlador().imprimirPIM(GetObjConstantes()._FICHA, newHash);

                var codEmpresa = (tieneParametros) ? sacaParametro('emp', newHash) : '';
                var stand = (tieneParametros) ? sacaParametro('s', newHash) : '';
                GetObjControlador().cargarFichaEmpresa(codEmpresa, stand);
            }
            else if (newHash.search("#FAVORITOS") >= 0)
            {
                if (GetObjConfiguracion().verPIM === 'S')
                    GetObjControlador().imprimirPIM(GetObjConstantes()._FAVORITOS, newHash);

                GetObjConfiguracion().numPagina = (newHash.indexOf('&') > 0) ? sacaParametro('p', newHash) : "";
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'F');
                GetObjControlador().cargarListaEmpresasFavoritas();
                GetObjControlador().saveAnalyticsOtros("Favoritos", "");
            }
            else if (newHash.search("#LEMPRESAS") >= 0)
            {
                if (GetObjConfiguracion().verPIM === 'S')
                    GetObjControlador().imprimirPIM(GetObjConstantes()._LISTA, newHash);

                $('#loading-indicator').show();

                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                GetObjListaEmpresas().activarBtnTodasEmpresas();
                GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                GetObjListaEmpresas().setBusquedaActiva("#btnTodasEmpresas");
                if (!GetObjControlador().saveAnalyticsFiltros(""))
                    GetObjControlador().saveAnalyticsOtros("Búsqueda Empresas", "");
            }
            else if (newHash.search("#LSECTOR") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('s', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnSector();
                        GetObjControlador().cargarListaSectores(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice Sectores", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._SECTOR, newHash);

                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#LPAISES") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('c', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnPais();
                        GetObjControlador().cargarListaPaises(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice País/Provincia", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._PAIS, newHash);

                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#LACTIVIDAD") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('a', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnActividad();
                        GetObjControlador().cargarListaActividades(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice Actividades", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._ACTIVIDAD, newHash);

                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#LPRODUCTOS") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('o', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnProducto();
                        GetObjControlador().cargarListaProductos(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice Productos", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._PRODUCTO, newHash);
                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#LREPRESENTADAS") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('r', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnRepresentadas();
                        GetObjControlador().cargarListaRepresentadas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice Representadas", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._REPRESENTADA, newHash);
                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#LMARCAS") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('m', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnMarcas();
                        GetObjControlador().cargarListaMarcas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice Marcas", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._MARCA, newHash);
                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#LSTANDS") >= 0)
            {
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('st', newHash);
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = "";

                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnStands();
                        GetObjControlador().cargarListaStands(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice Stands", "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._STAND, newHash);
                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
            else if (newHash.search("#GEN") >= 0)
            {
                if (tieneVariosParametros) codigoTipoGenerico = sacaParametro('g', newHash); //identificador el generico
                if (tieneVariosParametros) opcionElegidaIndice = sacaParametro('s', newHash); //subgenerico dentro de genérico
                $('#loading-indicator').show();
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (opcionElegidaIndice.length == 0)
                {
                    GetObjConfiguracion().filtroBusquedaActiva = '';
                    setTimeout(function ()
                    {
                        CatalogoWebUI.setIdOpcionElegida("");
                        GetObjListaEmpresas().activarBtnGenerico(codigoTipoGenerico);
                        GetObjControlador().cargarListaGenericos(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda, codigoTipoGenerico);
                        if (!GetObjControlador().saveAnalyticsFiltros(""))
                            GetObjControlador().saveAnalyticsOtros("Índice G: " + CatalogoWebUI.getTituloGenerico(codigoTipoGenerico), "");
                    }, 0);
                }
                else
                {
                    if (GetObjConfiguracion().verPIM === 'S')
                        GetObjControlador().imprimirPIM(GetObjConstantes()._GENERICO, newHash);
                    GetObjConfiguracion().filtroBusquedaActiva = opcionElegidaIndice;
                    GetObjControlador().cargarListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    GetObjControlador().visualizarEmpresas();
                }
            }
        }
    }
};

ObjNavegacion.prototype = {
}
